<template>
    <div>
        <b-modal :no-close-on-backdrop="true" body-class="px-0" id="modal-Check-FollowUp" title="Remark" hide-footer :centered="true" v-model="open">
            <div class="pl-20 pr-20">
                <!-- <b-form-group label="Keep it for next job" class="b-color photosThumb keep-it-for-next-job clear-both mt-0 mb-30">
                    <b-form-checkbox :disabled="checkEditChecklist()" v-model="iskeepNextJob"></b-form-checkbox>
                    <b-form-checkbox v-model="isfollowUp" :disabled="isfollowUpUpdate == true"></b-form-checkbox>
                </b-form-group> -->
                <b-form-group label="Remarks" class="clear-both text-remark notFloat">
                    <b-form-textarea :disabled="checkEditChecklist()" v-model="checkListItem.follow_up.description" class="notFloat" rows="4"></b-form-textarea>
                    <!--  <b-form-textarea :disabled="!isfollowUp" v-model="checkListItem.follow_up.description" class="notFloat " rows="4"></b-form-textarea> -->
                </b-form-group>
                <!-- <gofix-form-dropdown class="m-0" :disabled="checkEditChecklist()" v-model="checkListItem.preset_actions" label="Action" :options="presetActions"></gofix-form-dropdown> -->
                <b-form-group label="photos" class="photosThumb clear-both">
                    <ul class="list-thumb">
                        <li v-for="(item,key) in checkListItem.follow_up.attachments" v-bind:key="key">
                            <img v-auth-image="item.url.thumb" src="img/loading.gif" :alt="item.image_file_name || 'image'" />
                            <span v-if="!checkEditChecklist()" class="delete" @click="deleteFollowUp(item)">
                                <img src="img/close.png" alt />
                            </span>
                        </li>
                    </ul>
                    <div class="upload-btn-wrapper">
                        <b-form-file :disabled="checkEditChecklist()" id="fileInputMulti" v-model="imgFollowUp" :plain="true" :multiple="true"></b-form-file>
                        <gofix-button :disabled="checkEditChecklist()" class="m-3" label="add photo" outline></gofix-button>
                    </div>
                </b-form-group>
            </div>
            <!-- <template v-if="item && item.entry_issue_sources && item.entry_issue_sources.issue_register">
                <hr class="w-100"/>
                <div class="pl-20 pr-20">
                    <b-row>
                        <b-col cols="12">
                            <h4 class="mt-2 mb-3">Action Taken</h4>
                        </b-col>
                        <b-col cols="12">
                            <gofix-form-input-date
                                class="mb-4"
                                :disabled="checkEditChecklist()"
                                v-model="checkListItem.action_taken_date_rectified"
                                label="Date">
                            </gofix-form-input-date>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group label="Description " class="clear-both text-remark notFloat">
                                <b-form-textarea 
                                    :disabled="checkEditChecklist()" 
                                    v-model="checkListItem.action_taken_description" 
                                    class="notFloat" 
                                    rows="4">
                                </b-form-textarea>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group label="photos" class="photosThumb clear-both">
                                <ul class="list-thumb">
                                    <li v-for="(item,key) in checkListItem.action_taken_photos" v-bind:key="key">
                                        <img v-auth-image="item.url.thumb" :alt="item.image_file_name || 'image'" />
                                        <span style="z-index: 0" v-if="!checkEditChecklist()" class="delete" @click="deleteActionTaken(item)">
                                            <img src="img/close.png" alt />
                                        </span>
                                    </li>
                                </ul>
                                <div class="upload-btn-wrapper">
                                    <b-form-file :disabled="checkEditChecklist()" id="fileInputMulti" v-model="imgActionTaken" :plain="true" :multiple="true"></b-form-file>
                                    <gofix-button :disabled="checkEditChecklist()" class="m-3" label="add photo" outline></gofix-button>
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </template> -->
            <b-button-group class="d-block text-right pl-10 pr-10">
                <gofix-button v-if="item && item.follow_up && item.follow_up.id" @click="resetRemark" :loading="isDeleteAction" :disabled="checkEditChecklist()" label="DELETE" class="mr-3 pull-left mt-10" noBorder></gofix-button>
                <!-- <gofix-button label="" :disabled="checkEditChecklist()" class="mr-3" @click="showPriority" :loading="isActionFollow" noBorder>
                    <template slot="gofix:button:beforeLabel">APPLY &amp;<br/> FOLLOW UP</template>
                </gofix-button> -->
                <gofix-button :disabled="checkEditChecklist()" label="APPLY" @click="updateRemark" :loading="isAction" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <priority :loading="modal.sla.loading" :service-category-id="modal.sla.service_category_id" @raise-issue="raiseIssue" v-model="modal.sla.open"></priority>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    const Priority = () => import('./modal_priority.vue')
    import moment from 'moment';
    export default {
        name: 'modal-remark-follow-up',
        components: {
            Priority
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            item: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                open: false,
                checkListItem: {
                    follow_up: {
                        description: "",
                        remark_type: "JobFollowUp",
                        key_of_list: null,
                        attachments: [],
                        preset_actions: null,
                    },
                    preset_actions: null,
                    // action_taken_date_rectified: null,
                    // action_taken_description: null,
                    // action_taken_photos: []
                },
                isAction: false,
                isActionFollow: false,
                isDeleteAction: false,
                imgActionTaken: null,
                imgActionTakenAction: {
                    photos: [],
                    delete: [],
                },
                imgFollowUpAction: {
                    photos: [],
                    delete: [],
                },
                imgFollowUp: null,
                iskeepNextJob: false,
                modal: {
                    sla: {
                        open: false,
                        loading: false,
                        service_category_id: null
                    },
                }
            }
        },
        computed: {
            ...mapGetters({
                Item: "JobController/Item"
            }),
            presetActions() {
                return this.Item && this.Item.maintenance && this.Item.maintenance.preset_actions ? this.Item.maintenance.preset_actions : []
            }
        },
        mounted() {
        },
        created() {},
        watch: {
            open: function(val) {
                this.$emit('input', val);
                if(val) {
                    this.iskeepNextJob = false
                    this.checkListItem.follow_up = {
                        description: "",
                        remark_type: "JobFollowUp",
                        key_of_list: null,
                        attachments: [],
                        preset_actions: null,
                    }
                    this.checkListItem.preset_actions = null
                    // this.checkListItem.action_taken_date_rectified = null
                    // this.checkListItem.action_taken_description = null
                    // this.checkListItem.action_taken_photos = []
                    if(this.item) {
                        this.checkListItem.follow_up = Object.assign(this.checkListItem.follow_up, this.item.follow_up)
                        this.checkListItem.preset_actions = this.item.preset_actions || null
                        // if(this.item.entry_issue_sources && this.item.entry_issue_sources.issue_register) {
                        //     this.checkListItem.action_taken_date_rectified = this.item.entry_issue_sources.issue_register.action_taken_date_rectified ? moment(this.item.entry_issue_sources.issue_register.action_taken_date_rectified).toDate() : null
                        //     this.checkListItem.action_taken_description = this.item.entry_issue_sources.issue_register.action_taken_description || null
                        //     this.checkListItem.action_taken_photos = this.item.entry_issue_sources.issue_register.action_taken_photos && this.item.entry_issue_sources.issue_register.action_taken_photos.attachments ? this.item.entry_issue_sources.issue_register.action_taken_photos.attachments : []
                        // }
                    }
                }
            },
            value: function(val) {
                this.open   = val;
            },
            imgFollowUp(val, old) {
                if (val) {
                    val.forEach((file) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment: moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            },
                        };
                        this.imgFollowUpAction.photos.push(file);
                        this.checkListItem.follow_up.attachments.push(data);
                    });
                }
            },
            imgActionTaken(val) {
                if (val) {
                    val.forEach((file, index) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf() + index;
                        let data = {
                            moment: moment().valueOf() + index,
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            },
                        };
                        this.imgActionTakenAction.photos.push(file);
                        this.checkListItem.action_taken_photos.push(data);
                    });
                }
            },
        },
        methods: {
            checkEditChecklist() {
                if(!this.Item || !this.Item.job_status) return true;
                // if(this.Item.job_status == 'Expired' || this.Item.job_status == 'Verified' || this.Item.job_status == 'Cancelled' ||this.Item.job_status == 'Endorsed')
                if(this.Item.maintenance && this.Item.maintenance.editing_of_issue && !this.Item.maintenance.editing_of_issue.includes(this.Item.job_status))
                    return true
                if(['Completed'].includes(this.Item.job_status) && !this.$checkRole(this.$accessModule.allow_editing_job_completed, 'allow_editing_job_completed'))
                    return true;
                if(['Verified'].includes(this.Item.job_status) && !this.$checkRole(this.$accessModule.allow_editing_job_verified, 'allow_editing_job_verified'))
                    return true;
                // if(this.item && this.item.is_follow_up) 
                //     return true
                // if(this.Item.job_status == 'Completed' && !(this.Item.maintenance && this.Item.maintenance.is_allow_editing_of_follow_up_after_job_completion)) 
                //     return true
                return false
            },
            updateRemark() {
                if (this.isAction) return;
                this.isAction = true;
                let data = {
                    id: this.item.id,
                    data: this.checkListItem.follow_up,
                    action: this.imgFollowUpAction,
                    is_follow_up: false,
                    is_keep_next_job: this.iskeepNextJob,
                    remark_id: this.item.remark_id,
                    preset_actions: this.checkListItem.preset_actions,
                    // action_taken_photos: this.imgActionTakenAction.photos,
                    // action_taken_description: this.checkListItem.action_taken_description,
                    // action_taken_date_rectified: this.checkListItem.action_taken_date_rectified ? moment(this.checkListItem.action_taken_date_rectified).format("YYYY-MM-DD"): null
                };
                this.updated(data);
            },
            updateFollowUp(sla_id) {
                if (this.isActionFollow) return;
                this.isActionFollow = true;
                let data = {
                    id: this.item.id,
                    data: this.checkListItem.follow_up,
                    action: this.imgFollowUpAction,
                    is_follow_up: true,
                    is_keep_next_job: this.iskeepNextJob,
                    sla_id: sla_id,
                    remark_id: this.item.remark_id,
                    preset_actions: this.checkListItem.preset_actions,
                    // action_taken_photos: this.imgActionTakenAction.photos,
                    // action_taken_description: this.checkListItem.action_taken_description,
                    // action_taken_date_rectified: this.checkListItem.action_taken_date_rectified ? moment(this.checkListItem.action_taken_date_rectified).format("YYYY-MM-DD"): null
                };
                
                this.updated(data);
            },
            updated(data) {
                this.$store
                    .dispatch("CheckListController/checklistEntriesFollowUp", data)
                    .then((result) => {
                        this.imgFollowUpAction = { photos: [], delete: [] };
                        this.imgActionTakenAction = { photos: [], delete: [] };
                        this.$alertNotification(this.$notificationV2("editing", "checklist"));
                        this.isAction = false;
                        this.isActionFollow = false;
                        this.isDeleteAction = false;
                        this.open = false;
                        this.modal.sla.loading  = false;
                        this.modal.sla.open     = false;
                        this.$emit('reloadChecklist')
                    })
                    .catch((error) => {
                        this.isAction = false;
                        this.isActionFollow = false;
                        this.isDeleteAction = false;
                        this.modal.sla.loading  = false;
                    });
            },
            deleteFollowUp(img) {
                if (img.moment) {
                    this.checkListItem.follow_up.attachments = this.checkListItem.follow_up.attachments.filter(
                        (item) => item.moment != img.moment
                    );
                    this.imgFollowUpAction.photos = this.imgFollowUpAction.photos.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    this.checkListItem.follow_up.attachments = this.checkListItem.follow_up.attachments.filter(
                        (item) => item.id != img.id
                    );
                    this.$store.dispatch("JobController/deleteAttachmentsFollowUp", {
                        ids: [img.id],
                        key_of_list: this.checkListItem.follow_up.key_of_list,
                    });
                }
            },
            deleteActionTaken(img) {
                if (img.moment) {
                    this.checkListItem.action_taken_photos = this.checkListItem.action_taken_photos.filter(
                        (item) => item.moment != img.moment
                    );
                    this.imgActionTakenAction.photos = this.imgActionTakenAction.photos.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    this.checkListItem.action_taken_photos = this.checkListItem.action_taken_photos.filter(
                        (item) => item.id != img.id
                    );
                    this.$store.dispatch("AttachmentController/removeAttachments", {
                        ids: [img.id]
                    });
                }
            },
            showPriority() {
                this.open = false;
                this.modal.sla.service_category_id = this.Item.service_category_id;
                this.modal.sla.open  = true;
            },
            raiseIssue(sla_id) {
                this.modal.sla.loading = true;
                this.updateFollowUp(sla_id);
            },
            resetRemark(){
                if (this.isDeleteAction) return;
                this.isDeleteAction = true;
                let data = {
                    id: this.item.id,
                    data: {
                        description: null
                    },
                    action: [],
                    is_follow_up: false,
                    is_keep_next_job: false,
                    remark_id: null,
                    preset_actions: null,
                    // action_taken_photos: [],
                    // action_taken_description: null,
                    // action_taken_date_rectified: null
                };
                
                this.updated(data);
            }
        }
    }
</script>
